import { Election } from '~/definitions/election';
import { getStore } from '~/mobx/AppStore';

function getSelectedElectionById(id: string) {
    const { generalSettingsStore } = getStore();
    const { electionList = [] } = generalSettingsStore;
    const selectedElection = electionList?.filter((election: Election) => election.id === id);
    const selectedElectionData = selectedElection?.[0] || [];
    return selectedElectionData;
}

export default getSelectedElectionById;
